import {
  type RouteProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { isWeb } from '../utils';
import type { RootStackParamList } from '../types/RootStackParamList';

export const useRootStackNavigation = <
  RouteName extends keyof RootStackParamList,
>() => {
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList, RouteName>>();

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else if (isWeb) {
      history.back();
    }
  };

  return {
    ...navigation,
    goBack,
  };
};

export const useRootRoute = <RouteName extends keyof RootStackParamList>() => {
  return useRoute<RouteProp<RootStackParamList, RouteName>>();
};
